import { PaymentElement } from "@stripe/react-stripe-js";
import React, { useState, useEffect } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Box, Flex, Text } from "@chakra-ui/layout";
import {
  Stack,
  Image,
  VStack,
  Center,
  Circle,
  Spacer,
  Divider,
  Input,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import ModalRight from "../../components/modal-right";
import {
  DropdownInput,
  PrimaryButton,
  PrimaryButtonIcon,
  PrimaryInput,
  SearchBar,
  Toaster,
} from "../../components";
import { useNavigate } from "react-router-dom";
import { SavePayment } from "../../middleware/services/payment/payment";
import { loadStripe } from "@stripe/stripe-js";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import {updateSubscriptionPlan } from "../../middleware/services/signup";



export default function CheckoutForm({planid}) {
  const stripe = useStripe();
  const elements = useElements();
  var navigate = useNavigate();
  const [patientid, setPatientID] = useState("");
  const [doctorid, setDoctorId] = useState("")
  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { showSuccessToast, showErrorToast } = Toaster();
  const addcard = React.useRef();
  const { isLoading, showLoader, dismissLoader } = useLoader();


  useEffect(() => {
    addcard.current.openRight();
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
    
    }, [stripe]);

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);
    const {paymentIntent, error } = await stripe.confirmPayment({
      elements,
      // confirmParams: {
      //   // Make sure to change this to your payment completion page
      //   return_url: `${window.location.origin}/completion`,
      // },
      redirect:"if_required",
    });

    if (error) {
      console.log(error, "error");
      showErrorToast (error.message);
      var result = await SavePayment(error)
      //console.log(result, "failed payment save db");
      
      dismissLoader();
      //setMessage(error.message);
    }
    else if (paymentIntent && paymentIntent.status === 'succeeded') {
      //console.log(paymentIntent,"paymentIntent");     
      //window.location.href('http://localhost:3000/completion');
      showSuccessToast ("Payment Successful!");
      // setMessage(paymentIntent.status);
      paymentIntent.paymenttypeid = "1";
      var response = await SavePayment(paymentIntent)
      //console.log(result, "payment save db")
      const result = await updateSubscriptionPlan({
        planid,
        doctorid,
      });
          //console.log(result , " result of professiontl details")
  
          if (result.output.result == "success") {
  
            //showSuccessToast("Successfully Updated")
            window.location.reload();
          
          }else {
            console.error(result, "Something went wrong in Submit.")
            showErrorToast("Something went wrong!")
          }
    } 
    else {
      showErrorToast("An unexpected error occured.");
    }

    setIsProcessing(false);
  };
  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    
    <ModalRight
          ref={addcard}
          header="Payment"
          bodyStyle={{ p: "24px 32px" }}
          modalWidth="400px"
          body={
            <>
              <Flex>
                <Box w="100%">
                  <Center>
                    <VStack spacing={6} w="450px">
                      {/* <img
                        alt="not found"
                        width={"250px"}
                        src={selectedImage}
                      /> */}
                      {/* <Image
                        alt="Uploaded medication"
                        src="/assets/imgs/card-png.png"
                        objectFit="contain" // This will ensure the aspect ratio is maintained without stretching
                      /> */}
                        <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />      
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
                     
                    </VStack>
                  </Center>
                </Box>
              </Flex>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" alignItems="center" gap="15px">
               
                <PrimaryButton
                  onClick={handleSubmit}
                  buttonText="Pay"
                  // isDisabled={isProcessing || !stripe || !elements} 
                  id="submit"
                />
              </Box>
            </>
          }
        />
    
  );
}
